
import { Link } from 'react-router-dom';
import { Button } from "@/components/ui/button";
import { ArrowRight, Phone } from 'lucide-react';
import logoSvg from '@/assets/images/logo.svg';

interface CallToActionProps {
  variant?: 'primary' | 'secondary';
  title?: string;
  description?: string;
  children?: React.ReactNode;
}

const CallToAction = ({ 
  variant = 'primary', 
  title = "Ready to find your next commercial property in Colombo?",
  description = "Whether you're looking to buy, sell, or lease commercial real estate in Sri Lanka, we have the expertise and listings to help you succeed.",
  children 
}: CallToActionProps) => {
  return (
    <section className={`py-20 ${variant === 'primary' ? 'bg-propertylk-blue' : 'bg-propertylk-darkblue'}`}>
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="flex justify-center mb-6">
          <img 
            src={logoSvg} 
            alt="Commercial Property LK Logo" 
            className="h-16 w-auto brightness-0 invert"
          />
        </div>
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">{title}</h2>
        <p className="text-lg text-white/80 mb-8">
          {description}
        </p>
        {children ? (
          children
        ) : (
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button 
              className="bg-white text-propertylk-blue hover:bg-gray-100 transition-colors text-lg px-8 py-6"
              asChild
            >
              <Link to="/properties">Browse Properties</Link>
            </Button>
            <Button 
              variant="secondary" 
              className="bg-propertylk-gold text-propertylk-darkblue hover:bg-propertylk-gold/90 font-semibold transition-colors text-lg px-8 py-6 flex items-center gap-2"
              asChild
            >
              <Link to="/contact">
                <Phone className="h-5 w-5" />
                Contact an Agent
              </Link>
            </Button>
          </div>
        )}
        <div className="mt-8 inline-block">
          <Link to="/register" className="text-white hover:text-white/90 font-medium flex items-center group">
            Are you a property owner in Sri Lanka? List your property
            <ArrowRight className="ml-2 h-4 w-4 group-hover:translate-x-1 transition-transform" />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default CallToAction;
